export default function YourAccount() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Your Account</h2>
      <p className="text-sm text-text_muted">Manage your profile and account details.</p>
    </div>
  );
}
